import { createStore } from "redux";

const initialState = {
  reduxEmail: "-",
  reduxPhone: "-",
  reduxStreet: "-",
  reduxZip: "-"
};
const reducer = (state = initialState, action) => {
    //console.log(action.payload);
  // const newState = { ...state };
  switch (action.type) {
    case "ADD_EMAIL":    
      return {...state, reduxEmail: action.payload}
    case "ADD_PHONE":    
      return {...state, reduxPhone: action.payload}
    case "ADD_STREET":    
      return {...state, reduxStreet: action.payload}
    case "ADD_ZIP":    
      return {...state, reduxZip: action.payload}
    case "ADD_ACCOUNT":
      return {...state, reduxAccount: action.payload}
    case "ADD_SERVICE":
      return {...state, reduxService: action.payload}
    case "EDIT":    
      return {...state, reduxPhone: action.payload.reduxPhone, reduxEmail: action.payload.reduxEmail, reduxStreet: action.payload.reduxStreet, reduxZip: action.payload.reduxZip}
    default:
      return state;
  }
};

const store = createStore(reducer);

// store.subscribe(() => {
// 	return store.getState();
// });

export default store;


// WEBPACK FOOTER //
// ./src/store/index.jsx